import AuthenticationProvider from '@/components/shared/security/authentication-provider'
import * as ROUTES from '@/router/route-names'
import store from '@/store/store'
import { getAuthenticatedUser } from '@/components/shared/security/auth-utils'
import AdminRoutes from './admin-routes'
import FormRoutes from './forms-routes'

const NO_LOGIN_REQUIRED_ROUTES = [
  ROUTES.PRE_REGISTRATION_PAGE,
  ROUTES.REGISTRATION_PAGE,
  ROUTES.LOGIN_PAGE,
  ROUTES.INVITE_PAGE,
  ROUTES.BROKER_INVITE_PAGE,
  ROUTES.FORGOT_PASSWORD,
  ROUTES.PASSWORD_RESET,
  ROUTES.SUBMISSION_DOWNLOAD,
  ROUTES.PRICING,
  ROUTES.HIGHWING_DEMO_ROUTE,
  ROUTES.DATA_REQUEST_USER,
  ROUTES.HIGHWING_DEMO_USER_ROUTE,
  ROUTES.SIGNATURE,
  ROUTES.PROSPECT_QUESTIONNAIRE,
  ROUTES.OPEN_APPS_LANDING,
  ROUTES.OPEN_APPS_FORM,
  ROUTES.FORBIDDEN,
]
const ADMIN_PAGES = AdminRoutes.map(r => r.name)
const FORM_PAGES = FormRoutes.map(r => r.name)

class AuthenticatedGuard {
  static isLoggedIn() {
    return store.getters.isLoggedIn
  }

  static isAnAdmin() {
    return store.getters.isAnAdmin
  }

  static isBrokerUser() {
    return store.getters.isBrokerageUser
  }

  static isTfaValidated() {
    return store.getters.isTfaValidated
  }

  static setRedirectUrl(url) {
    store.commit('SET_REDIRECT_URL', url)
  }

  static isAuthenticated() {
    return AuthenticatedGuard.isLoggedIn() && AuthenticatedGuard.isTfaValidated()
  }

  static authedAccounts() {
    const token = AuthenticationProvider.getJwsPayload()
    if (token) {
      return token.accts
    } else {
      return []
    }
  }

  static use(router) {
    router.beforeEach(async (to, from, next) => {
      let isLoggedIn = AuthenticatedGuard.isAuthenticated()
      let isAnAdmin = AuthenticatedGuard.isAnAdmin()
      let isBrokerUser = AuthenticatedGuard.isBrokerUser() || isAnAdmin
      // Repeated Below - after /me call

      if (to.name === null) {
        next({ name: ROUTES.NOT_FOUND_PAGE })
        return
      }

      if (NO_LOGIN_REQUIRED_ROUTES.includes(to.name)) {
        // Global OK routes
        next()
        return
      }

      // The rest of the routes require to be logged in, try logging in
      if (!isLoggedIn) {
        await getAuthenticatedUser()
        isLoggedIn = AuthenticatedGuard.isAuthenticated()
        isAnAdmin = AuthenticatedGuard.isAnAdmin()
        isBrokerUser = AuthenticatedGuard.isBrokerUser() || isAnAdmin
      }

      if (!AuthenticatedGuard.isLoggedIn()) {
        AuthenticatedGuard.setRedirectUrl(to.fullPath)
      }

      if (ADMIN_PAGES.includes(to.name)) {
        //Admin secured routes
        if (isAnAdmin) {
          next()
          return
        }
        if (!isLoggedIn) {
          next({ name: ROUTES.LOGIN_PAGE })
          return
        }

        // Logged in, but not an admin
        next({ name: ROUTES.NOT_FOUND_PAGE })
        return
      }

      if (FORM_PAGES.includes(to.name)) {
        //Broker secured route
        if (isBrokerUser) {
          next()
        } else {
          next({ name: ROUTES.NOT_FOUND_PAGE })
        }
      }

      if (isLoggedIn) {
        // We checked No Login Required pages first
        // And We checked Admin Required pages
        next()
      } else {
        next({ name: ROUTES.LOGIN_PAGE })
      }
    })
  }
}

export default AuthenticatedGuard
